<template>
  <section class="contact-section" v-if="items">
    <div class="contact-header">
      <h1 class="contact-title">
        {{ $t("Contact") }}
      </h1>
    </div>
    <v-row>
      <v-col cols="12" md="4">
        <div class="contact-left-section">
          <!-- Image Card -->
          <div class="contact-image-card">
            <img :src="contactus" :alt="$t('Contact')" class="contact-image" />
          </div>
          
          <!-- Contact Info Grid -->
          <div class="contact-info-grid">
            <h3 class="contact-info-title">
              {{ $t("contact_information") }}
            </h3>
            <p class="contact-info-subtitle">
              {{ $t("We_are_here") }}
            </p>
            
            <div class="contact-info-items">
              <div class="contact-info-item" v-if="items.phone">
                <a :href="`tel:+${items.phone}`" class="contact-link">
                  <v-icon icon="mdi-phone-outline" class="contact-icon"></v-icon>
                  <span>{{ items.phone }}</span>
                </a>
              </div>
              
              <div class="contact-info-item" v-if="items.email">
                <a :href="`mailto:${items.email}`" class="contact-link">
                  <v-icon icon="mdi-email-outline" class="contact-icon"></v-icon>
                  <span>{{ items.email }}</span>
                </a>
              </div>
              
              <div class="contact-info-item" v-if="items.whatsapp">
                <a
                  :href="`https://api.whatsapp.com/send?phone=${items.whatsapp}`"
                  target="_blank"
                  class="contact-link"
                >
                  <v-icon icon="mdi-whatsapp" class="contact-icon"></v-icon>
                  <span>{{ items.whatsapp }}</span>
                </a>
              </div>
            </div>
            
            <!-- Social Links -->
            <div class="social-links-grid" v-if="items.facebook || items.instagram || items.twitter || items.tiktok || (items.socials && items.socials.tiktok)">
              <a
                v-if="items.facebook"
                :href="items.facebook"
                target="_blank"
                class="social-link-item"
              >
                <v-icon icon="mdi-facebook"></v-icon>
              </a>
              <a
                v-if="items.instagram"
                :href="items.instagram"
                target="_blank"
                class="social-link-item"
              >
                <v-icon icon="mdi-instagram"></v-icon>
              </a>
              <a
                v-if="items.twitter"
                :href="items.twitter"
                target="_blank"
                class="social-link-item"
              >
                <v-icon icon="mdi-twitter"></v-icon>
              </a>
              <a
                v-if="items.tiktok || (items.socials && items.socials.tiktok)"
                :href="items.tiktok || items.socials?.tiktok"
                target="_blank"
                class="social-link-item tiktok-link"
              >
                <img :src="tiktokIcon" alt="TikTok" class="tiktok-svg-icon" />
              </a>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-row class="mt-sm-1 mt-2">
          <v-col cols="12" lg="6">
            <label class="form-label">
              {{ $t("firstname") }}
            </label>
            <v-text-field
              variant="solo"
              class="contact-input"
              v-model="formData.fname"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <label class="form-label">
              {{ $t("lastname") }}
            </label>
            <v-text-field
              variant="solo"
              class="contact-input"
              v-model="formData.lname"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <label class="form-label">
              {{ $t("phone_number") }}
            </label>
            <v-text-field
              type="tel"
              variant="solo"
              class="contact-input"
              v-model="formData.phone"
              @input="validatePhoneNumber"
            ></v-text-field>
            <div v-if="invalidPhoneNumber" class="error-message">
              {{ validationMessage }}
            </div>
          </v-col>
          <v-col cols="12" lg="6">
            <label class="form-label">
              {{ $t("email") }}
            </label>
            <v-text-field
              variant="solo"
              class="contact-input"
              v-model="formData.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label class="form-label">
              {{ $t("Message_Subject") }}
            </label>
            <v-text-field
              variant="solo"
              class="contact-input"
              v-model="formData.subject"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-2">
              <label class="form-label">
                {{ $t("message") }}
              </label>
              <span class="char-count">
                {{ $t("Maximum_characters") }}
              </span>
            </div>

            <v-textarea
              variant="solo"
              class="contact-input"
              v-model="formData.message"
            ></v-textarea>
          </v-col>
          <div class="error-message">{{ errorMessage ? errorMessage : "" }}</div>
        </v-row>

        <button class="contact-submit-btn" @click="contact">
          {{ $t("Send") }}
        </button>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="showSnackbar"
      color="yellow-darken-1
"
    >
      {{ $t("You_answered_soon") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" v-bind="attrs" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </section>
  <v-row v-else>
    <v-col cols="12" v-for="text in texts" :key="text">
      <v-skeleton-loader
        class="mx-auto border-0"
        type="paragraph"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>
<script>
  import crudDataService from "@/Services/crudDataService";
  import contact from "../../assets/images/contactus.png";
  import Path from "../../assets/images/Path.png";
  import tiktokIcon from "@/assets/icon/tiktok.svg";
  export default {
    data() {
      return {
        items: "",
        contactus: contact,
        Path: Path,
        tiktokIcon: tiktokIcon,
        texts: [1, 2, 3, 4],
        showSnackbar: false,
        errorMessage: "",
        invalidPhoneNumber: false,
        validationMessage: "",
        formData: {
          phone: "",
          message: "",
          fname: "",
          lname: "",
          email: "",
          subject: "",
        },
      };
    },
    methods: {
      validatePhoneNumber() {
        const isNegative = this.formData.phone.startsWith("-");
        const isNumeric = /^\d+$/.test(this.formData.phone);
        this.invalidPhoneNumber = isNegative || !isNumeric;
        this.validationMessage = this.$t("enterValidPhoneNumber");
      },
      async getcontact() {
        let response = await crudDataService.getAll("application-data");
        this.items = response.data.data;
      },
      async contact() {
        let response = await crudDataService
          .create("contact-us", this.formData)
          .then((res) => {
            console.log(res, "wdjqpowjpwd");
            this.showSnackbar = true;
            (this.formData.phone = ""),
              (this.formData.message = ""),
              (this.formData.lname = ""),
              (this.formData.fname = ""),
              (this.formData.email = ""),
              (this.formData.subject = ""),
              (this.errorMessage = "");
          })
          .catch((error) => {
            this.errorMessage = error.response.data.message;
          });
      },
    },
    mounted() {
      this.getcontact();
    },
  };
</script>
<style lang="scss" scoped>
.contact-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 32px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contact-header {
  text-align: center;
  margin-bottom: 32px;
}

.contact-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin: 0;
}

.contact-left-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-image-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contact-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.contact-info-grid {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contact-info-title {
  font-size: clamp(18px, 2.5vw, 22px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.contact-info-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.contact-info-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.contact-info-item {
  display: flex;
  align-items: center;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s ease;
  
  &:hover {
    color: #0074c7;
  }
}

.contact-icon {
  color: #0074c7;
  font-size: 20px;
}

.social-links-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.social-link-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    background: #0074c7;
    color: #ffffff;
    transform: translateY(-2px);
  }
}

.tiktok-link {
  color: #000000 !important;
  
  &:hover {
    background: #0074c7;
  }
}

.tiktok-svg-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0);
  transition: filter 0.2s ease;
}

.tiktok-link:hover .tiktok-svg-icon {
  filter: brightness(0) invert(1);
}

.form-label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.contact-input {
  :deep(.v-field__input) {
    background: #f7f7f7;
    border-radius: 8px;
  }
}

.char-count {
  font-size: 12px;
  color: #666;
}

.error-message {
  color: #d32f2f;
  font-size: 14px;
  margin-top: 4px;
}

.contact-submit-btn {
  width: 100%;
  padding: 14px 24px;
  background: #0074c7;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;
  
  &:hover {
    background: #005a9e;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 116, 199, 0.3);
  }
}

@media (max-width: 960px) {
  .contact-left-section {
    margin-bottom: 32px;
  }
}

@media (max-width: 600px) {
  .contact-section {
    padding: 24px;
  }
  
  .contact-info-grid {
    padding: 20px;
  }
  
  .social-links-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
